import {GET_WIKTIONARY,CLOSE_WIKTIONARY} from '../actions/actionTypes'

export default (state = false, action) => {
    switch (action.type) {

        case GET_WIKTIONARY:
            return true;

        case CLOSE_WIKTIONARY:
            return false;

        default:
            return state;
    }
};